import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import EmployeeDetails from "./EmployeeDetails";
import EmployeeSalary from "../salaries/index";
import EmployeeSchedule from "../schedules/index";
import EditSettingEmployee from "../settings/edit";
import AssignedAssets from "../assigned-assets/index";
import Documents from "../documents/index";
import CustomTabs from "components/tabs/customTab";
import AccessButton from "components/button/accessbutton";
import {
  User,
  Wallet,
  Calendar,
  Package,
  Settings,
  FileText
} from "lucide-react";

const EmployeeTab = ({ recordId }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const pathParts = location.pathname.split("/").filter(Boolean);
  const lastSegment = pathParts[pathParts.length - 1];
  const [activeTab, setActiveTab] = useState(lastSegment);

  const items = [
    { 
      value: "view", 
      label: "Details", 
      icon: <User />,
      children: 
        <EmployeeDetails recordId={recordId} /> 
    },
    { 
      value: "employee-salaries", 
      label: "Salary", 
      icon: <Wallet />,
      children: 
        <EmployeeSalary employeeId={recordId} /> 
    },
    { 
      value: "schedules", 
      label: "Schedule List", 
      icon: <Calendar />,
      children: 
        <EmployeeSchedule employeeId={recordId} /> 
    },
    { 
      value: "documents", 
      label: "Documents", 
      icon: <FileText />,
      children: 
        <Documents employeeId={recordId} /> 
    },
    { 
      value: "assigned-assets", 
      label: "Assigned Assets", 
      icon: <Package />,
      children: 
        <AssignedAssets employeeId={recordId} /> 
    },
    { 
      value: "settings", 
      label: "Settings", 
      icon: <Settings />,
      children: 
        <EditSettingEmployee employeeId={recordId} /> 
    },
  ];

  const onChange = (value) => {
    setActiveTab(value);
    navigate(`/console/employees/${recordId}/${value}`);

  };

  return (
    <div>
      <div className="flex items-center justify-between mb-4">
          <AccessButton
            backLabel="Employees"
            withBack={true}
            baseRoute="/console/employees"
          />

          <div className="flex-1 ml-2">
              <CustomTabs
                tabs={items}
                activeTab={activeTab}
                onChange={onChange}
                height="h-10"
              />
          </div>
      </div>

      <div className="mt-6">
        {items.find(item => item.value === activeTab)?.children}
      </div>
    </div>
  );
};

export default EmployeeTab;
